<template>
  <layout kind="one_column">
    <div class="text-xs-center">
      <page-title header="Compartilhar cadastro" />
    </div>
    <v-layout row wrap>
      <v-flex xs12 offset-md3 md6>
        <v-card class="mb-3" style="border-radius: 10px;" v-if="state == 'initial'">
          <v-container>
            <v-layout row wrap px-3>
              <v-flex xs12 class="title" style="font-weight: normal; line-height: 1.5!important;" pa-3 text-xs-center>
                Para autorizar que seus dados cadastrais sejam acessados, clique no botão abaixo:
              </v-flex>
            </v-layout>
          </v-container>
          <v-card-actions>
            <v-layout column>
              <v-flex xs12>
                <v-btn
                  block
                  dark
                  class="ma-0 btn-style--secondary"
                  @click="allowSubjectDataSharing()"
                >
                  PERMITIR COMPARTILHAMENTO
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-actions>
        </v-card>

        <v-card class="mb-3" style="border-radius: 10px;" v-if="state == 'confirmed'">
          <v-container>
            <v-layout row wrap px-3>
              <v-flex xs12 class="title" style="font-weight: normal; line-height: 1.5!important;" pa-3 text-xs-center>
                Compartilhamento de dados cadastrais autorizado.
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>

        <v-card class="mb-3" style="border-radius: 10px;" v-if="state == 'error'">
          <v-container>
            <v-layout row wrap px-3>
              <v-flex xs12 class="title" style="font-weight: normal; line-height: 1.5!important;" pa-3 text-xs-center>
                Houve um erro ao tentar autorizar o compartilhamento de seus dados cadastrais.<br/>
                Para tentar novamente, clique no botão abaixo:
              </v-flex>
            </v-layout>
          </v-container>
          <v-card-actions>
            <v-layout column>
              <v-flex xs12>
                <v-btn
                  block
                  dark
                  class="ma-0 btn-style--secondary"
                  @click="allowSubjectDataSharing()"
                >
                  PERMITIR COMPARTILHAMENTO
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </layout>
</template>

<script>
import HomeLayout from "./layouts/HomeLayout"
import Title from "./components/Title"

export default {
  name: 'AllowSubjectDataSharing',
  components: { layout: HomeLayout, 'page-title': Title },
  data: () => {
    return {
      state: 'initial'
    }
  },
  methods: {
    allowSubjectDataSharing() {
      this.state = 'processing'

      const payload = {
        id: this.$route.params.id
      }

      let successCallback = (response) => {
        this.state = 'confirmed'
      }

      let errorCallback = (response) => {
        this.state = 'error'
      }

      this.$http.post(this.$root.urls.allow_subject_data_sharing, payload).then(successCallback, errorCallback)
    }
  },
  mounted() {
  },
  metaInfo: {
    title: "Facilita Pay"
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/AllowSubjectDataSharing.vue